// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskFormalCriteriaCitations } from './taskFormalCriteriaCitations';

/**
 * Formal criteria for a task submission
 */
export interface TaskFormalCriteria {
  wordcount: number;
  wordcountTolerance: number;
  citations?: TaskFormalCriteriaCitations;
  minInTextCitations?: number;
}
